module.exports = __webpack_public_path__ + "img/configwarn.f1e03c91.svg";